import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { QueryReceiptDto, ReceiptPageResult, ReceiptItem } from './types/receipt';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/receipts';

export async function queryReceipts(
  params: QueryReceiptDto,
  options?: ApiRequestOptions,
) {
  return request<ReceiptPageResult>(BASE_PATH, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getReceiptDetail(
  uuid: string,
  options?: ApiRequestOptions,
) {
  return request<ReceiptItem>(`${BASE_PATH}/${uuid}`, {
    method: 'GET',
    ...(options || {}),
  });
}
